import { render, staticRenderFns } from "./PaymentProgressStatusBox.vue?vue&type=template&id=58256af4&scoped=true&"
import script from "./PaymentProgressStatusBox.vue?vue&type=script&lang=js&"
export * from "./PaymentProgressStatusBox.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProgressStatusBox.vue?vue&type=style&index=0&id=58256af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58256af4",
  null
  
)

export default component.exports